// src/extenders/cart-page-recommendations.js
var CartRecommendationsSlider = class extends HTMLElement {
  /**
   * Creates an instance of CartRecommendationsSlider
   */
  constructor() {
    super();
    console.log("[cart-page-recommendations] constructor \u2014 element created", new Error().stack);
    this.init();
  }
  /**
   * Initializes the component by checking for existing recommendations
   * and fetching new ones if needed
   */
  init() {
    const url = this.dataset.url;
    const elements = this.querySelectorAll(".swiper-slide");
    if (elements.length === 0) {
      this.fetchRecommendations(url);
    }
  }
  /**
   * Fetches product recommendations from the given URL and updates the component
   * @param {string} url - The URL to fetch recommendations from
   * @returns {Promise<void>}
   */
  async fetchRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector("cart-page-recommendations");
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
      }
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    }
  }
};
if (!customElements.get("cart-page-recommendations")) {
  customElements.define("cart-page-recommendations", CartRecommendationsSlider);
}
